<template>
  <div class="expose-container" data-testid="expose-container">
    <div>
      <label>Expose Inner Clothes:</label>
      <toggle
        :on="isUnderEnabled"
        :disabled="readonly"
        :on-color="'green-3'"
        @toggle="toggleUnder()"
      />
    </div>
  </div>
</template>

<script>
import { keyBy } from 'lodash';
import Toggle from '../common/Toggle';

export default {
  name: 'expose-patient',
  components: {
    Toggle,
  },
  props: {
    caseConf: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selectedProcedureMap() {
      return keyBy(this.caseConf._treatments, 'id');
    },
    isUnderEnabled() {
      const selectedProcedure = this.selectedProcedureMap['UPPER_UNDERWEAR_REMOVED'];
      return !!(selectedProcedure && selectedProcedure.options.enabled);
    },
  },
  mounted() {
    const doUpdate1 = this.ensureExistence('UPPER_CLOTHES_REMOVED');
    const doUpdate2 = this.ensureExistence('LOWER_CLOTHES_REMOVED');
    const doUpdate3 = this.ensureExistence('UPPER_UNDERWEAR_REMOVED');
    const doUpdate4 = this.ensureExistence('LOWER_UNDERWEAR_REMOVED');
    if (doUpdate1 || doUpdate2 || doUpdate3 || doUpdate4) {
      this.update(this.caseConf._treatments);
    }
  },
  methods: {
    ensureExistence(id) {
      if (!this.caseConf._treatments || !this.caseConf._treatments.find(t => t.id === id)) {
        if (!this.caseConf._treatments) {
          this.caseConf._treatments = [];
        }
        const newTreament = {
          id,
          options: {
            enabled: true,
          },
        };
        this.caseConf._treatments.push(newTreament);
        return true;
      }      
    },
    toggleUnder() {
      const upper = this.selectedProcedureMap['UPPER_UNDERWEAR_REMOVED'];      
      upper.options.enabled = !upper.options.enabled;

      const lower = this.selectedProcedureMap['LOWER_UNDERWEAR_REMOVED'];
      lower.options.enabled = upper.options.enabled;

      this.update(this.caseConf._treatments);
    },
    update(treatments) {
      this.$emit('update', { _treatments: treatments});
    }
  }
}
</script>

<style scoped>
.expose-container {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
}
label {
  display: block;
  line-height: normal;
  margin-bottom: 2px;
}
</style>